/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable id-length */
import React, { useEffect } from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { array, bool, func, number, object, string, oneOfType } from 'prop-types'
import ValidacaoFluxosPagamento from '../components/ValidacaoFluxosPagamento'
import ResumoAssinaturaConclusao from './ResumoAssinaturaConclusao'
import ResumoPagamentoConclusao from './ResumoPagamentoConclusao'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { PromocaoProvider } from '../../../contexts/PromocaoContext'
import { ETAPA_CONCLUSAO, ETAPA_ENTREGA, ETAPA_PAGAMENTO, ETAPA_PLANO, ETAPA_BRINDES, TITULO_TELA_CONCLUSAO, BOTAO_GERAR_PIX } from '../constantsFluxosPagamento'
import { METODO_PAGAMENTO_PIX, PLANO_MENSAL, PLANO_ANUAL } from '../../../constants'
import { empty, isEmptyObject } from '../../../utils/helpers/helpers'
import { calcularParcelas } from '../../../utils/formatter/formatter'
import {
  getFreteDaModalidade,
  getInformacoesModalidadePorAssinatura
} from '../../../utils/helpers/helpersAssinatura'

const WrapperTelaConclusao = styled.div`
  h2 {
    margin-bottom: 20px;
  }
`

const WrapperColunasResumoConclusao = styled.div`
  h4 {
    ${StyleGuide.tipografia.textoDefault}
    ${StyleGuide.boldFonte}
  }

  .info {
    margin: 5px 0;
  }

  @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
  }
`

const ConteudoDireitoConclusao = styled.div`
  max-width: 400px;
  min-width: 250px;
  position: relative;
  width: 100%;
`
const ConteudoEsquerdoConclusao = styled.div`
  max-width: 350px;
`

const LoadingWrapper = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, .7);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;
`

const TelaConclusao = ( {
  dadosRetornoRequisicao,
  concluirFluxo,
  etapaAtual,
  idAssinatura,
  dadosDescontoCombo,
  fluxo,
  fluxoTemPromocao,
  labelBotaoUltimaEtapa,
  loadingRequisicao,
  location,
  modalidadeSelecaoPlano,
  primeiraEtapa,
  respostaRequisicao,
  setDescontoTotalSegundaAssinatura,
  tipoAssinaturaPromocao
} ) => {
  const { modalidadeURL, dadosGlobaisAssociado } = useGlobal()
  const {
    dadosEtapas,
    setarDadosEtapas,
    brinde,
    temaFluxo,
    setEtapaAtiva,
    calculaDescontoPix,
  } = useFluxosPagamento()
  const hasDadosEtapa = !isEmptyObject( dadosEtapas )
  const hasDadosPagamento = hasDadosEtapa && !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] )
  const hasDadosPlano = hasDadosEtapa && !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] )
  const hasDadosEntrega = hasDadosEtapa && !isEmptyObject( dadosEtapas[ ETAPA_ENTREGA ] )
  const isPix = hasDadosPagamento && dadosEtapas[ ETAPA_PAGAMENTO ].metodoPagamento === METODO_PAGAMENTO_PIX.slug
  const valorTotalPlanoConclusao = hasDadosPlano && Number( dadosEtapas[ ETAPA_PAGAMENTO ].plano.valor )
  const valorPlanoConclusao = hasDadosPlano && calcularParcelas(
    dadosEtapas[ ETAPA_PAGAMENTO ].plano.tipo,
    dadosEtapas[ ETAPA_PAGAMENTO ].plano.valor
  )
  const modalidadeSelecionadaConclusao = modalidadeURL && getInformacoesModalidadePorAssinatura( modalidadeSelecaoPlano || modalidadeURL )
  let labelBotao = labelBotaoUltimaEtapa
  const freteEntrega =
    hasDadosEntrega &&
    getFreteDaModalidade( dadosEtapas[ ETAPA_ENTREGA ].frete, modalidadeSelecionadaConclusao?.id )
  const getPrecoFreteEntrega = ( valorFreteEntrega ) => {
    if ( isEmptyObject( valorFreteEntrega ) || empty( valorFreteEntrega.preco ) ) {
      return null
    }

    const preco = Number( valorFreteEntrega.preco )

    return isPix ? calculaDescontoPix( preco ) : preco
  }
  const rawPrecoFreteEntrega = getPrecoFreteEntrega( freteEntrega )
  const filterValorEntregaEnvioUnico = ( valorEntrega ) => {
    if ( valorEntrega === null ) {
      return null
    }

    return dadosEtapas[ ETAPA_ENTREGA ].hasEnvioUnico ? valorEntrega * 0.7 : valorEntrega
  }
  const precoFreteEntrega = filterValorEntregaEnvioUnico( rawPrecoFreteEntrega )

  if ( isPix ) {
    labelBotao = BOTAO_GERAR_PIX
  }

  useEffect(
    () => {
      if ( hasDadosPagamento && dadosEtapas[ ETAPA_PAGAMENTO ].metodoPagamento === METODO_PAGAMENTO_PIX.slug ) {
        setarDadosEtapas(
          { 'isConclusaoPreenchida': true },
          etapaAtual.identificador
        )
      }
    },
    []
  )

  if ( isEmptyObject( dadosEtapas[ ETAPA_PLANO ] ) && etapaAtual.identificador === ETAPA_CONCLUSAO ) {
    return <InlineLoader
      cor={ temaFluxo }
      isCenter
    />
  }
  useEffect(
    () => {
      if ( !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] ) && dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_ANUAL.visualizacao ) {
        const semInfoBrinde = !Object.keys( dadosEtapas ).includes( ETAPA_BRINDES ) || isEmptyObject( dadosEtapas[ ETAPA_BRINDES ] )
        if ( semInfoBrinde && brinde ) {
          setarDadosEtapas(
            brinde,
            ETAPA_BRINDES
          )
        }
      }
    },
    [ dadosEtapas[ ETAPA_PLANO ] ]
  )

  return (
    <ValidacaoFluxosPagamento
      concluirFluxo={ () => concluirFluxo(
        dadosEtapas,
        setEtapaAtiva
      ) }
      dadosRetornoRequisicao={ dadosRetornoRequisicao }
      etapaAtual={ etapaAtual }
      labelBotaoUltimaEtapa={ labelBotao }
      loadingRequisicao={ loadingRequisicao }
      location={ location }
      primeiraEtapa={ primeiraEtapa }
      respostaRequisicao={ respostaRequisicao }
      tipoFluxo={ fluxo }
    >
      {dadosEtapas && isEmptyObject( dadosEtapas ) ? (
        <InlineLoader
          cor={ temaFluxo }
          isCenter />
      ) : (
        <WrapperTelaConclusao>
          <h2>{`${TITULO_TELA_CONCLUSAO} ${fluxo}`}</h2>

          <WrapperColunasResumoConclusao>
            <ConteudoEsquerdoConclusao>
              <ResumoAssinaturaConclusao
                dadosDescontoCombo={ dadosDescontoCombo }
                dadosGlobaisAssociado={ dadosGlobaisAssociado }
                hasDadosEntrega={ hasDadosEntrega }
                hasDadosPlano={ hasDadosPlano }
                modalidadeSelecionadaConclusao={
                  !isEmptyObject( modalidadeSelecionadaConclusao ) &&
                  modalidadeSelecionadaConclusao
                }
                precoFreteEntrega={ precoFreteEntrega }
                showMessageRenovacaoAutomatica={
                  dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_ANUAL.visualizacao
                }
                tipoFluxo={ fluxo }
                valorPlanoConclusao={
                  hasDadosEtapa &&
                  dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_MENSAL.visualizacao
                    ? valorTotalPlanoConclusao
                    : valorPlanoConclusao
                }
              />
            </ConteudoEsquerdoConclusao>

            <ConteudoDireitoConclusao>
              <PromocaoProvider>
                {loadingRequisicao ?
                  <LoadingWrapper>
                    <InlineLoader
                      cor={ temaFluxo }
                      isCenter />
                  </LoadingWrapper> : null}

                <ResumoPagamentoConclusao
                  dadosDescontoCombo={
                    dadosDescontoCombo ? dadosDescontoCombo.desconto : null
                  }
                  dadosGlobaisAssociado={ dadosGlobaisAssociado }
                  etapaAtual={ etapaAtual }
                  fluxoTemPromocao={ fluxoTemPromocao }
                  hasDadosEtapa={ hasDadosEtapa }
                  hasDadosPagamento={ hasDadosPagamento }
                  hasDadosPlano={ hasDadosPlano }
                  idAssinatura={ idAssinatura }
                  labelBotaoUltimaEtapa={ labelBotao }
                  modalidadeSelecionadaConclusao={
                    !isEmptyObject( modalidadeSelecionadaConclusao ) &&
                    modalidadeSelecionadaConclusao
                  }
                  precoFreteEntrega={ precoFreteEntrega }
                  setDescontoTotalSegundaAssinatura={ setDescontoTotalSegundaAssinatura }
                  tipoAssinaturaPromocao={ tipoAssinaturaPromocao }
                  tipoFluxo={ fluxo }
                  valorPlanoConclusao={ valorPlanoConclusao }
                  valorTotalPlanoConclusao={ valorTotalPlanoConclusao }
                />
              </PromocaoProvider>
            </ConteudoDireitoConclusao>
          </WrapperColunasResumoConclusao>
        </WrapperTelaConclusao>
      )}
    </ValidacaoFluxosPagamento>
  )
}

TelaConclusao.defaultProps = {
  'dadosDescontoCombo': false,
  'dadosRetornoRequisicao': null,
  'fluxoTemPromocao': false,
  'idAssinatura': null,
  'loadingRequisicao': false,
  'modalidadeSelecaoPlano': '',
  'setDescontoTotalSegundaAssinatura': () => null,
}

TelaConclusao.propTypes = {
  'concluirFluxo': func.isRequired,
  'dadosDescontoCombo': oneOfType( [ object, bool ] ),
  'dadosRetornoRequisicao': oneOfType( [ array, object ] ),
  'etapaAtual': object.isRequired,
  'fluxo': string.isRequired,
  'fluxoTemPromocao': bool,
  'idAssinatura': number,
  'labelBotaoUltimaEtapa': string.isRequired,
  'loadingRequisicao': bool,
  'location': object.isRequired,
  'modalidadeSelecaoPlano': string,
  'primeiraEtapa': string.isRequired,
  'respostaRequisicao': bool.isRequired,
  'setDescontoTotalSegundaAssinatura': func.isOptional,
  'tipoAssinaturaPromocao': string.isRequired,
}

export default TelaConclusao
